import api from './api';

export const getPosSeriesConfig = async () => {
  const response = await api.get('/ventas/pos-series-config');
  return response.data;
};

export const updatePosSeriesAssignment = async (pointOfSaleId, documentType, series) => {
  const response = await api.put(`/ventas/pos-series-config/${pointOfSaleId}`, {
    document_type: documentType,
    series: series || null,
  });
  return response.data;
};
